import { useNavigate, useOutletContext } from 'react-router-dom';
import { CarretillaIconSVG, TranspaletaIconSVG } from './ui/FormControls';
import { LIMITE_DESCARGAS_FREE, AVISO_DESCARGAS_DESDE } from '../utils/cuotaFree';

const PLANTILLAS_FREE = [
  { slug: "carretillas", label: "Checklist carretillas elevadoras", icon: <CarretillaIconSVG />, desc: "Supervisión diaria" },
  { slug: "transpaletas", label: "Checklist transpaletas", icon: <TranspaletaIconSVG />, desc: "Manuales y eléctricas" },
  { slug: "mantenimiento", label: "Plan mantenimiento instalaciones", icon: "🏭", desc: "Diario / semanal / mensual" },
  { slug: "flota", label: "Flota", icon: "🚚", desc: "Checklist completo de vehículo" },
  { slug: "vehiculo-expres", label: "Vehículo Exprés", icon: "🚐", desc: "Checklist rápido diario" },
];

// ── PLAN FREE: pantalla de inicio ─────────────────────────────────
export const FreeInicioSection = () => {
  const navigate = useNavigate();
  const { nombreEmpresa, descargasUsadas = 0 } = useOutletContext() || {};
  const alcanzado = descargasUsadas >= LIMITE_DESCARGAS_FREE;
  const cercaDelLimite = descargasUsadas >= AVISO_DESCARGAS_DESDE;

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-black text-gray-800">Hola{nombreEmpresa ? `, ${nombreEmpresa}` : ""} 👋</h2>
        <p className="text-xs text-gray-500 uppercase font-semibold tracking-wide mt-1">Tus plantillas</p>
      </div>

      {cercaDelLimite && (
        <div className={`rounded-lg px-3 py-2 text-xs font-semibold border ${alcanzado ? "bg-red-50 border-red-200 text-red-700" : "bg-yellow-50 border-yellow-200 text-yellow-800"}`}>
          {alcanzado
            ? "Has alcanzado el límite de 40 descargas este mes."
            : `Te quedan ${LIMITE_DESCARGAS_FREE - descargasUsadas} descargas este mes.`}
        </div>
      )}

      <div className="space-y-3">
        {PLANTILLAS_FREE.map(t => (
          <div key={t.slug} onClick={() => navigate(`/app/free/${t.slug}`)} className="bg-white rounded-xl shadow p-4 flex items-center gap-4 cursor-pointer hover:bg-blue-50 border border-gray-100">
            <div className="w-11 h-11 rounded-xl bg-blue-100 flex items-center justify-center text-blue-700 text-xl">{t.icon}</div>
            <div className="flex-1">
              <p className="font-semibold text-gray-800 text-sm">{t.label}</p>
              <p className="text-xs text-gray-500">{t.desc}</p>
            </div>
            <span className="text-gray-400 text-sm">›</span>
          </div>
        ))}
      </div>
    </div>
  );
};
